import React, { useState } from 'react'
import { NavItems } from './NavItems'
import NavBurger from '@atoms/NavBurger'
import datas from '@datas/rubriques.json'
import './nav.scss'

const Nav = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	const handleClick = () => {
		setIsMenuOpen(!isMenuOpen)
	}

	return (
		<>
			<ul
				className={`nav ${isMenuOpen ? 'is-open' : ''}`}
				onClick={() => {
					handleClick()
				}}
			>
				<NavItems datas={datas} />
			</ul>
			<NavBurger handleClick={handleClick} isMenuOpen={isMenuOpen} />
		</>
	)
}
export default Nav
